import Numeral from 'numeral/numeral'

Numeral.register('locale', 'custom', {
  delimiters: {
    thousands: ' ',
    decimal: '.'
  },
  abbreviations: {
      thousand: 'k',
      million: 'm',
      billion: 'b',
      trillion: 't'
    },
    ordinal: function () {
      return '.';
    },
    currency: {
      symbol: 'usd'
    },
  }
);
Numeral.locale('custom');


function formatVolume(value, limit=1000, decimal=true) {
  let format;
  if(decimal) {
    format = '0,0.0';
  } else {
    format = '0,0';
  }

  if(Math.abs(value) < Numeral(limit).value()) {
    // don't format
    return Numeral(value).format('0,0')
  } else if(Math.abs(value) > Numeral('1b').value() && value < Numeral('10b').value()) {
    // display billions as millions (numeral doesn't support "m" formatting)
    const millions = Numeral(value / Numeral('1m').value()).format(format)
    return `${millions}m`
  } else {
    // auto format
    return Numeral(value).format(`${format}a`);
  }
}

function formatCount(value) {
  if (value < Numeral('100k').value()) {
    // don't shorten a number
    return Numeral(value).format('0,0');
  } else if(value > Numeral('1b').value() && value < Numeral('10b').value()) {
    // display billions as millions (numeral doesn't support "m" formatting)
    const millions = Numeral(value / Numeral('1m').value()).format('0,0.0')
    return `${millions}m`
  } else {
    // auto format
    return Numeral(value).format('0,0.0a');
  }
}

function formatPercent(value, format=null) {
  const defaultFormat = '0.0%';

  if(format) {
    return Numeral(value).format(format);
  }

  if(Number.isInteger(value * 100)) {
    // example: 0.12 to "12%"
    return Numeral(value).format('0%');
  } else {
    // example: 0.124 to "12.4%", when format is "0.0%"
    return Numeral(value).format(defaultFormat);
  }
}

function formatFloat(value, format=null) {
  const defaultFormat = '0.00';
  return Numeral(value).format(format || defaultFormat);
}

export {
  formatVolume,
  formatCount,
  formatPercent,
  formatFloat,
}
